import { 
  loadinghtml,
  errorhtml
} from './templates'
import {
  initPlaybackControls 
} from './playbackcontrol'

(function($) {

  window.ispringPresentationConnector = {}

  window.academyStartCourse = () => { 

    if(!window.academystatus.userlogged) {

      $('body').append(`
        <div id="NoLoggedUser">
          <div class="Message"> 
            ${ __('You need to be identified to access our courses. Please login or sign up.') }
          </div>
          <div class="Close">
            ${ __('Login/Register') }
          </div>
        </div>
      `)

      const $nologgeduser = $('body').find('#NoLoggedUser') 
      const $close = $nologgeduser.find('.Close')  

      $close
      .on(
        'click',
        function() {

          $nologgeduser.remove()

          $('html').css('overflow', 'auto')
          
          $('<div class="xoo-el-login-tgr"></div>').appendTo("body").click();
        }
      ) 

      window.scrollTo(0, 0);

      $('html').css('overflow', 'hidden')

      $nologgeduser.dialog({
        autoOpen: true,
        width: 300,
        height: 200,
        modal: true,
        resizable: false,
        draggable: false,
        title: __('No Logged user')
      })

      $nologgeduser.parent('.ui-dialog').attr('context', 'nologgeduser')

      return
    }

    window.scrollTo(0, 0);
    
    const $academyscorm = $('.wp-block-academy-scorm')
    const $scorm = $academyscorm.find('.Scorm')
    const $scormplayer = $('div.ScormPlayer')
    const $start = $('.ShortCode.CourseFeatures .Start')
    const data = $academyscorm.data()

    let $iframebody

    $scormplayer.addClass('Visible')           

    if(data.withspringnav) {
 
      const $ispringsummarytree = $scormplayer.find('.ISpringSummary .Tree')
      const $issprintnav = $scormplayer.find('.ISpringNav')
      const $issprintnavprogressbar = $issprintnav.find('.Progress .Bar')
      const $issprintnavreload = $issprintnav.find('.Reload')
      const $issprintnavfullscreen = $issprintnav.find('.FullScreen')
      const $issprintnavprev = $issprintnav.find('.Prev')
      const $issprintnavnext = $issprintnav.find('.Next')

      $issprintnavfullscreen
      .on(
        'click',
        function() {

          const elem = $scormplayer[0]
          if (elem.requestFullscreen) {

            elem.requestFullscreen()

          } else if (elem.webkitRequestFullscreen) {
            
            elem.webkitRequestFullscreen()

          } else if (elem.msRequestFullscreen) {

            elem.msRequestFullscreen()

          }
        }
      )

      $issprintnavprev.addClass('Disabled')
      $issprintnavnext.addClass('Disabled')             

      ispringPresentationConnector.register = function(player) {

        const presentation = player.presentation()
        const playbackController = player.view().playbackController()
        const slidesCount = presentation.slides().count()
        ispringPresentationConnector.presentation = presentation
        ispringPresentationConnector.playbackController  = playbackController
        presentation.slidesCount = slidesCount

        initPlaybackControls(
          $,
          data.ispringsummary,
          player,
          playbackController, 
          slidesCount,
          $ispringsummarytree,
          $issprintnavprogressbar,
          $issprintnavreload,
          $issprintnavfullscreen,
          $issprintnavprev,
          $issprintnavnext
        )        
      }

      $scormplayer.addClass('WithSpringNav')
    }          

    const fetchdata = new FormData()
    fetchdata.append('userid', window.academystatus.userid)  
    fetchdata.append('academycourseid', window.academystatus.courseid)  
    fetchdata.append('time', new Date().getTime()) 

    fetch(
      '/wp-json/academy/scorm/read', 
      {
        method: 'POST',
        headers: {
          'X-WP-Nonce': academy_web_site.nonce
        },
        body: fetchdata
      }
    )
    .then(response => {

      if(response.status == 200){
      
        response.json().then(result => {

          if(result != 'new') {

            const scormdatastring = result.scorm_data || '{}'
            const scormdatastringclean = scormdatastring.split('\\').join('')
            const scormdata = JSON.parse(scormdatastringclean || '{}')
            
            window.API.setData(scormdata)

            const ispringslidestotal = result.ispring_slides_total ? parseInt(result.ispring_slides_total) : 0
            const ispringslideslastvisited = result.ispring_slides_last_visited ? parseInt(result.ispring_slides_last_visited) : 0
            const ispringslidesactualvisited = result.ispring_slides_actual_visited ? parseInt(result.ispring_slides_actual_visited) : 0

            const ispringdata = {
              ispringslidestotal: ispringslidestotal,
              ispringslideslastvisited: ispringslideslastvisited,
              ispringslidesactualvisited: ispringslidesactualvisited,
              started: false
            }
            
            window.API.setISpringData(ispringdata)
          }
                
          $iframe.attr('src', data.scormpath + '/' + data.scormhref)
          
        })

      } else {

        $iframebody.html(errorhtml)     
      }
    })
    .catch(error => {
      
      $iframebody.html(errorhtml)
    })

    $('html').css('overflow', 'hidden')

    $scormplayer.dialog({
      autoOpen: true,
      width: '100%',
      height: '100%',
      modal: true,
      resizable: false,
      draggable: false,
      title: data.title,
      close: function() {

        $scormplayer.removeClass('Visible') 
        $scormplayer.removeClass('WithSpringNav') 
        $iframe.attr('src', '')
        
        window.API.setISpringData({
          started: false
        })
      }
    })

    $scormplayer.parent('.ui-dialog').attr('context', 'scormplayer')

    const $iframe = $('iframe.ScormContainer')
    $iframebody = $iframe.contents().find('body')
    $iframebody.html(loadinghtml)
  } 
  
})(jQuery)